/**
 * There will be one saga file per component
 */
import { takeEvery, fork, all } from 'redux-saga/effects';
import { GET_BARCODE_ITEMS } from '../actions/actionTypes';
import barcodeScannerSaga from './barcodeScanner';

function* watchGetBarcodeItems() {
    yield takeEvery(GET_BARCODE_ITEMS, barcodeScannerSaga);
}
export default function* barcodeDetailsSaga() {
    yield all([fork(watchGetBarcodeItems)]);
}
